import axios from "axios";

//
import CONSTS from "../../utils/consts";
// import history from "../../router/histrory";

const $api = axios.create({
  baseURL: CONSTS.BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

function onRequest(req) {
  let token = window.localStorage.getItem(CONSTS.APP_TOKEN);
  if (token) {
    token = JSON.parse(token);
    req["headers"]["Authorization"] = "Bearer " + token;
  }

  return req;
}

function onRequestError(err) {
  return Promise.reject(err);
}

function onResponse(res) {
  return res;
}

function onResponseError(err) {
  return Promise.reject(err);
}

$api.interceptors.request.use(onRequest, onRequestError);
$api.interceptors.response.use(onResponse, onResponseError);

export default $api;
